var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container pt-4"},[_c('b-message',{staticClass:"has-text-centered",attrs:{"type":"is-warning"}},[_vm._v(" Converted value is: "),_c('strong',[_vm._v(_vm._s(_vm.result))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }